import {TranslationObject} from '@colonist/i18n'
import {setElementInnerText} from '../ui_utils/DomUtils'
import FaviconOrange from '@static/images/favicon_orange.png'

export class UIBrowserTabController {
    private static readonly pageTitle: HTMLTitleElement = document.getElementById('browser_tab') as HTMLTitleElement
    private static readonly favicon: HTMLLinkElement = document.getElementById('favicon') as HTMLLinkElement

    private static readonly defaultTitle = UIBrowserTabController.pageTitle.innerHTML
    private static readonly defaultFavIcon = UIBrowserTabController.favicon.href

    private static resetTabTitleAndFavIcon() {
        setElementInnerText(this.pageTitle, {key: 'strings:colonistCommon.utils.#buffer', options: {value: this.defaultTitle}})
        this.favicon.href = this.defaultFavIcon
    }

    static blinkTab(text: TranslationObject) {
        setElementInnerText(this.pageTitle, text)
        this.favicon.href = FaviconOrange
        setTimeout(() => this.resetTabTitleAndFavIcon(), 1000)
    }
}
